/* import __COLOCATED_TEMPLATE__ from './activity-download-button.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { select } from '@banking/ui/services/savings-reporter';
import { Action, Route, getEvent } from '@banking/ui/utils/statements-cdp-events';
import { collapsedCsvExportLink, expandedCsvExportLink, BASEURL } from '@banking/ui/workflows/unified-activity/unified-activity';
let ActivityDownloadButton = (_dec = select(collapsedCsvExportLink), _dec2 = select(expandedCsvExportLink), _class = class ActivityDownloadButton extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "events", _descriptor, this);
    _initializerDefineProperty(this, "collapsedCsvExportLink", _descriptor2, this);
    _initializerDefineProperty(this, "expandedCsvExportLink", _descriptor3, this);
  }
  get isUsingBalanceReporter() {
    return this.args.exportActivitiesLink?.includes(BASEURL.balancereporter);
  }
  get isUsingSfs() {
    return this.collapsedCsvExportLink?.includes(BASEURL.sfscore) || this.expandedCsvExportLink?.includes(BASEURL.sfscore);
  }
  visitStatements() {
    if (this.isUsingBalanceReporter) {
      const event = getEvent(Action.Click, this.args.unitToken, {
        route: Route.Activity
      });
      this.events.track({
        kind: 'CDP',
        event
      });
    }
    this.args.goToStatements();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "events", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "collapsedCsvExportLink", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "expandedCsvExportLink", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "visitStatements", [action], Object.getOwnPropertyDescriptor(_class.prototype, "visitStatements"), _class.prototype), _class);
export { ActivityDownloadButton as default };